export const CANCEL_CART_ROSTER_ENTRY_FORM = 'CANCEL_CART_ROSTER_ENTRY_FORM';
export const SET_ROSTERS_COMPLETE = 'SET_ROSTERS_COMPLETE';
export const SET_EVENTS_FOR_ROSTER_CHECKOUT = 'SET_EVENTS_FOR_ROSTER_CHECKOUT';



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/constants.js